module.exports = __webpack_public_path__ + "static/media/reference.f5994172.svg";